import{useRef as e}from"react";function t(){const r=e(!0);return r.current?(r.current=!1,!0):r.current}export{t as default};
//# sourceMappingURL=useIsFirstRender.js.map
